import React, { use, useContext, useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {useCookies} from 'react-cookie';
import axios from 'axios';
import { base_url } from '../../url_variables';
import { TostMessageContext } from "../../context/TostMessage";
import ReactLoading from 'react-loading';
import { UserContext } from '../../context/UserContext';
import { ClockLoader } from "react-spinners";
import LOGO from '../../images/CLS-Logo.png';

function ChooseChildPage() {
    const [loading, setLoading] = useState(false);
    const [formFields, setFormFields] = useState({'email': '', 'password': ''});
    const { setTostMessage } = useContext(TostMessageContext);
    const [cookies, setCookie, removeCookie] = useCookies();
    const navigate = useNavigate();
    const {setUserProfile, userProfile} = useContext(UserContext);

    function getInitials (name) {
        return name
        .split(" ")
        .map((n) => n[0])
        .join("")
        .slice(0, 3)
        .toUpperCase();
    }

    useEffect(() => {
        // console.log(userProfile);
    })

    function loginAs(id, name, attendance) {
        const date = new Date();
        let expiresDate = date.setTime(date.getTime() + 24 * 60 * 60 * 1000); // 24 hours
        console.log(id, name);
        setUserProfile({...userProfile, sub_id: id, sub_name: name, name: name, account_type: 'sub', attendance: attendance});
        setCookie("userProfile", {...userProfile, sub_id: id, sub_name: name, name: name, account_type: 'sub', attendance: attendance}, {
            path: "/",
            maxAge: expiresDate,
            secure: true,
        });
        navigate('/home');
    }
    function parentLogin() {
        const date = new Date();
        let expiresDate = date.setTime(date.getTime() + 24 * 60 * 60 * 1000); // 24 hours
        setUserProfile({...userProfile, sub_id: userProfile?.child_array[0]?.id, sub_name: userProfile?.child_array[0]?.name, account_type: 'main', attendance: userProfile?.child_array[0]?.attendance});
        setCookie("userProfile", {...userProfile, sub_id: userProfile?.child_array[0]?.id, sub_name: userProfile?.child_array[0]?.name, account_type: 'main', attendance: userProfile?.child_array[0]?.attendance}, {
            path: "/",
            maxAge: expiresDate,
            secure: true,
        });
        navigate('/home');
    }
  return (
    <div className="relative h-screen h-full px-4">
        <div className="min-h-screen bg-gray-50 flex items-center justify-center relative">
            {/* Top Right Help/Support */}
            <div className="absolute top-4 right-6 flex space-x-4 text-sm text-gray-600">
                <a href="#" className="hover:underline">Help</a>
                <a href="#" className="hover:underline">Support</a>
            </div>

            {/* Login Card */}
            <div className='w-full flex flex-col items-center justify-center'>
                <div className='flex flex-col justify-start items-center w-full mt-[10px] mb-[30px]'>
                    <img src={LOGO} className="h-[80px] rounded-full mr-2" alt="logo" />
                    {/* <h1 className="font-bold text-[17px]">CHILDREN'S LANGUAGE SCHOOL</h1> */}
                </div>
                <div className="bg-white p-8 rounded-sm shadow-md w-full max-w-md">
                    <div className="mb-6 text-center">
                    <h1 className="text-2xl font-semibold text-gray-800">Continue As</h1>
                    <p className="text-sm text-gray-500 mt-1">Select an option</p>
                    </div>

                    <div className='my-4'>
                        <div className="mb-4">
                            <div onClick={() => parentLogin()} className='min-h-[61px] cursor-pointer py-4 px-3 flex flex-row items-center w-full rounded-[10px] bg-[#FAFAFA] border border-1'>
                                <div className="w-14 h-14 bg-yellow rounded-full flex items-center justify-center text-dark font-bold text-xl">
                                    {getInitials(userProfile?.name)}
                                </div>
                                <div className='flex flex-col ml-3'>
                                    <a className='font-semibold text-dark'>{userProfile?.name}</a>
                                    <a className='font-regular text-dark'>Parent</a>
                                </div>
                            </div>
                        </div>
                        <div className='w-full flex items-center justify-center mb-4'><a className='mx-auto text-gray text-sm'>or</a></div>
                        {userProfile?.child_array?.map((child, index) => {
                            return (
                                <div className="mb-4">
                                    <div onClick={() => loginAs(child.id, child.name, child.attendance)} className='min-h-[61px] cursor-pointer py-4 px-3 flex flex-row items-center w-full rounded-[10px] bg-[#FAFAFA] border border-1'>
                                        <div className="w-14 h-14 bg-yellow rounded-full flex items-center justify-center text-dark font-bold text-xl">
                                            {getInitials(child.name)}
                                        </div>
                                        <div className='flex flex-col ml-3'>
                                            <a className='font-semibold text-dark'>{child.name}</a>
                                            <a className='font-regular text-dark'>Class streak: {child.streak}</a>
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>
        </div>
    </div>
  );
}

export default ChooseChildPage;
